import { render } from "./IP.vue?vue&type=template&id=1d809395"
import script from "./IP.vue?vue&type=script&lang=js"
export * from "./IP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__